function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Helper for the box collaborators API
 * @author Box
 */
import MarkerBasedAPI from './MarkerBasedAPI';
import { DEFAULT_MAX_COLLABORATORS } from '../constants';

class FileCollaborators extends MarkerBasedAPI {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _defineProperty(this, "successHandler", data => {
      if (this.isDestroyed() || typeof this.successCallback !== 'function') {
        return;
      } // Transform into "mention selector" format:


      const collaboratorSelectorItems = data.entries.map(collab => {
        let item;

        if (collab.type === 'group') {
          item = collab; // flow needs assignment to happen after type refinement
        } else {
          item = collab;
          item.email = item.login; // transform user object
        }

        return {
          id: collab.id,
          name: collab.name,
          item
        };
      });
      this.successCallback(_objectSpread({}, data, {
        entries: collaboratorSelectorItems
      }));
    });

    _defineProperty(this, "getCollaboratorsWithQuery", function (fileId, successCallback, errorCallback, searchStr) {
      let {
        includeGroups = false
      } = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      // Do not fetch without filter
      if (!searchStr || searchStr.trim() === '') {
        return;
      }

      _this.getFileCollaborators(fileId, successCallback, errorCallback, {
        filter_term: searchStr,
        include_groups: includeGroups,
        include_uploader_collabs: false
      });
    });
  }

  /**
   * API URL for comments
   *
   * @param {string} [id] - a box file id
   * @return {string} base url for files
   */
  getUrl(id) {
    if (!id) {
      throw new Error('Missing file id!');
    }

    return "".concat(this.getBaseApiUrl(), "/files/").concat(id, "/collaborators");
  }
  /**
   * Transform result of API response
   *
   * @param {Object} data the response data
   */


  /**
   * API for fetching collaborators on a file
   *
   * @param {string} id - the file id
   * @param {Function} successCallback - the success callback
   * @param {Function} errorCallback - the error callback
   * @param {Object} requestData - any additional request data
   * @param {number} limit - the max number of collaborators to return
   * @returns {void}
   */
  getFileCollaborators(id, successCallback, errorCallback) {
    let requestData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_MAX_COLLABORATORS;
    // NOTE: successCallback is called with the result
    // of this.successHandler, not the API response!
    this.markerGet({
      id,
      limit,
      successCallback,
      errorCallback,
      requestData
    });
  }
  /**
   * Fetches file @mention's
   *
   * @oaram {string} fileId
   * @param {Function} successCallback
   * @param {Function} errorCallback
   * @param {string} searchStr - Search string to filter file collaborators by
   * @param {Object} [options]
   * @param {boolean} [options.includeGroups] - return groups as well as users
   * @return {void}
   */


}

export default FileCollaborators;
//# sourceMappingURL=FileCollaborators.js.map